import { render } from "./ConfigLiveDataHeaderPosition.vue?vue&type=template&id=428b3e62"
import script from "./ConfigLiveDataHeaderPosition.vue?vue&type=script&lang=js"
export * from "./ConfigLiveDataHeaderPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__